import { render, staticRenderFns } from "./travel-tile.vue?vue&type=template&id=38ede694&scoped=true&"
import script from "./travel-tile.vue?vue&type=script&lang=js&"
export * from "./travel-tile.vue?vue&type=script&lang=js&"
import style0 from "./travel-tile.vue?vue&type=style&index=0&id=38ede694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ede694",
  null
  
)

export default component.exports